"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VL_ONLY_GUIDE_CONFIG = ['shortTimeLabels'];